module.exports = __webpack_public_path__ + "img/T1C_xh_16.9b909ef4.png";